module.exports = __webpack_public_path__ + "static/media/HCMM182.9bf1d2aa.jpg";